// extracted by mini-css-extract-plugin
module.exports = {"item":"item___2QqTt","box":"box___dprnU","number":"number___2odkB","name":"name___13Hbg","tooltip":"tooltip___16H1Z"};